export default {
  QUEST_HELP_QUESTID: 'c-ac1e4f61-5247-40ee-96aa-6f89f26a8a2c',
  USER_ID: 'u-8165c25d-2e65-4585-b72e-4378a96051b2',
  APIKEY: 'k-3cecea4a-db63-493e-a7ca-1a839c7848e1',
  TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1LTgxNjVjMjVkLTJlNjUtNDU4NS1iNzJlLTQzNzhhOTYwNTFiMiIsImlhdCI6MTc1MzI4Nzc0MiwiZXhwIjoxNzU1ODc5NzQyfQ.gIv2F-PmK193O5Fn2ML2_bh5i3cvhU-6KLmt7ameHIM',
  ENTITYID: 'e-9323202b-f8a6-4273-9e8d-32a19f59472d',
  PRIMARY_COLOR: '#DC2626' // Extracted patriot-red color from your theme
};